import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    validacionIdentidad: true,
    eventoId: 0,
    participanteId: 0,
    eventoEtapaId: 0,

    validacionAprobada: false,
    observaciones: '',
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.validacionIdentidad = params.validacionIdentidad;
        state.eventoId = params.eventoId;
        state.participanteId = params.participanteId;
        state.eventoEtapaId = params.eventoEtapaId || 0;

        state.validacionAprobada = false;
        state.observaciones = '';
    },
    'SET_VALIDACION' (state, validacion) {
        state.validacionAprobada = (/true/i).test(validacion.validacionAprobada);
        state.observaciones = validacion.observaciones.trim();
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);
            resolve();

            // if (eventoId != 0) {
            //     /* Recuperamos los datos del evento */
            //     apiAxios.get('eventos/' + eventoId + '/abm' ) 
            //         .then(res => {
            //             commit('SET_EVENTO', res.data);
            //             resolve();
            //         })
            //         .catch(error => reject(helpers.methods.getErrorMessage(error)));
            // } else {
            //     resolve();
            // }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let validacion= {
                    participanteId: state.participanteId,
                    eventoEtapaId: state.eventoEtapaId,
                    validacionAprobada: (/true/i).test(state.validacionAprobada),
                    observaciones: state.observaciones.trim(),
                };
                
                let url = 'eventos/' + state.eventoId + '/participante/' + state.participanteId + '/validaciones';

                if ((/true/i).test(state.validacionIdentidad)) {
                    url += '/identidad';
                } else {
                    url += '/participacion';
                }

                apiAxios.post(url, validacion)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}